export default "__VITE_ASSET__ffaa6b80__"